import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
@Injectable({
    providedIn: 'root'
})
export class AlertsService {

    constructor(
        private toastr: ToastrService
    ) {
    }
    public success(message: string, title?: string) {
        return this.toastr.success(title || ' ', message);
    }
    public error(message: string, title?: string) {
        return this.toastr.error(title || ' ', message);
    }
    public alert(message: string, title?: string) {
        return this.toastr.warning(title || ' ', message);
    }
    public info(message: string, title?: string) {
        return this.toastr.info(title || ' ', message);
    }
}

